import { Component } from "react";

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[Bringy] App error:", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[#0D1B2A] px-6 py-16 text-center text-white">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50">Bringy</p>
          <h1 className="mt-4 font-display text-2xl font-bold">Something went wrong</h1>
          <p className="mx-auto mt-4 max-w-md text-sm text-white/70">
            Please refresh the page. If this keeps happening, try another browser or disable strict content blockers
            for this site.
          </p>
          <button
            type="button"
            className="mt-8 rounded-lg bg-[#2563EB] px-6 py-3 text-sm font-semibold text-white"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
